export default [
  {"value": "aggie", "label": "TAMU - Texas A&M University", "domain": "tamu.edu"},
  {"value": "blinn", "label": "Blinn College", "domain": "blinn.edu"},
  {"value": "bobcat", "label": "TXST - Texas State University", "domain": "txstate.edu"},
  {"value": "comet", "label": "UTD - University of Texas at Dallas", "domain": "utdallas.edu"},
  {"value": "commodore", "label": "Vanderbilt University", "domain": "vanderbilt.edu"},
  {"value": "cougar", "label": "UH - University of Houston", "domain": "uh.edu"},
  {"value": "gator", "label": "UF - University of Florida", "domain": "ufl.edu"},
  {"value": "longhorn", "label": "UT - University of Texas at Austin", "domain": "utexas.edu"},
  {"value": "raider", "label": "TTU - Texas Tech University", "domain": "ttu.edu"},
  {"value": "rebel", "label": "Ole Miss - University of Mississippi", "domain": "olemiss.edu"},
  {"value": "tiger", "label": "Clemson University", "domain": "clemson.edu"},
  {"value": "wolfpack", "label": "NCSU - NC State University", "domain": "ncsu.edu"}
]
